import { useQuery } from "@tanstack/react-query";
import { useAuthStore } from "@/features/auth/store/useAuthStore";
import { getMe } from "../services/me.app";

export const useMeInfo = () => {
  const isLogin = useAuthStore.use.isLogin();

  return useQuery({
    queryKey: ["me"],
    queryFn: getMe,
    enabled: isLogin,
  });
};
